import axios from 'axios';
import { Dispatch } from 'redux';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { IUser, toUser, userDto } from '@qwealth/qdata';

import { errorHandler, REACT_APP_QWEALTH_API } from 'services/axiosService';

export const fetchUsers = async (params: Record<string, string | number> = {}, dispatch: Dispatch): Promise<IUser[] | undefined> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API}/users`, { params });
    return responseListMapper<userDto>(response).map(toUser);
  } catch (e) {
    errorHandler(dispatch, 'Could not load users')(e);
    return undefined;
  }
};

export const postUser = async (payload: userDto, dispatch: Dispatch): Promise<IUser | undefined> => {
  try {
    const response = await axios.post(`${REACT_APP_QWEALTH_API}/users`, payload);
    return toUser(responseEntityMapper<userDto>(response));
  } catch (e) {
    errorHandler(dispatch, 'Could not create user. API Error')(e);
    return undefined;
  }
};

export const patchUser = async (payload: userDto, dispatch: Dispatch): Promise<IUser | undefined> => {
  try {
    const response = await axios.patch(`${REACT_APP_QWEALTH_API}/users/id/${payload.id}`, payload);
    return toUser(responseEntityMapper<userDto>(response));
  } catch (e) {
    errorHandler(dispatch, 'Could not save user. API Error')(e);
    return undefined;
  }
};

export const deleteUser = async (id: string, dispatch: Dispatch): Promise<string | undefined> => {
  try {
    await axios.delete(`${REACT_APP_QWEALTH_API}/users/id/${id}`);
    return id;
  } catch (e) {
    errorHandler(dispatch, 'Could not delete user. API Error')(e);
    return undefined;
  }
};
